/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReferralReferrerDto } from './referral-referrer-dto';
import { ReferralContactAttemptDto } from './referral-contact-attempt-dto';


export interface ProgramReferralDto { 
    age?: number;
    agencyName?: string;
    agencyReleaseDocumentSubmitted?: boolean;
    anger?: string;
    appointmentEditsAllowed?: boolean;
    cellPhone?: string;
    cityStateZip?: string;
    cognitiveBehavioral?: string;
    contactAttempts?: Set<ReferralContactAttemptDto>;
    courtOrdered?: boolean;
    criminalAssociatesPeers?: string;
    criminalInvolvement?: string;
    criminalOpportunity?: string;
    criminalPersonality?: string;
    criminalThinkingSelfReport?: string;
    currentViolence?: string;
    dateOfBirth?: string;
    defaultAppointmentDurationInHours?: number;
    email?: string;
    estimatedReleaseDate?: string;
    ethnicity?: string;
    familyCriminality?: string;
    financial?: string;
    firstName?: string;
    fullName?: string;
    gender?: string;
    generalRecidivismRisk?: string;
    guardianCityStateZip?: string;
    guardianEmail?: string;
    guardianName?: string;
    guardianPhone?: string;
    guardianPrimaryLanguage?: string;
    guardianStreet?: string;
    historyofNonCompliance?: string;
    historyofViolence?: string;
    isAdult?: boolean;
    isArsonist?: boolean;
    isSexOffender?: boolean;
    lastModified?: string;
    lastName?: string;
    legalStatus?: string;
    leisureandRecreation?: string;
    pcmsKey?: number;
    phone?: string;
    poEmail?: string;
    poName?: string;
    poPcmsKey?: number;
    poPhone?: string;
    pretrialReleaseRisk?: string;
    primaryLanguage?: string;
    probationStatus?: string;
    probationerId?: string;
    programName?: string;
    programReferralId?: string;
    recentAttendance?: Array<string>;
    referralDate?: string;
    referralStatus?: ProgramReferralDto.ReferralStatusEnum;
    referralStatusDate?: string;
    referrerInformation?: ReferralReferrerDto;
    residentialInstability?: string;
    riskLevel?: string;
    screenerName?: string;
    screeningDate?: string;
    socialAdjustmentProblems?: string;
    socialEnvironment?: string;
    socialIsolation?: string;
    socializationFailure?: string;
    ssn?: string;
    street?: string;
    substanceAbuse?: string;
    supervisionEndDate?: string;
    systemRecSupervisionLevel?: string;
    version?: number;
    violentRecidivismRisk?: string;
    vocationalEducation?: string;
}
export namespace ProgramReferralDto {
    export const ReferralStatusEnum = {
        Pending: 'PENDING',
        Accepted: 'ACCEPTED',
        Active: 'ACTIVE',
        Completed: 'COMPLETED',
        Cancelled: 'CANCELLED',
        Rejected: 'REJECTED',
        Removed: 'REMOVED'
    } as const;
    export type ReferralStatusEnum = typeof ReferralStatusEnum[keyof typeof ReferralStatusEnum];
}


